import { ChartDataType } from "../types/types";

export const hasZeroReferenceLine = (data: ChartDataType[]) => {
  return data?.some((item) =>
    Object.values(item).some((value) => value && +value < 0),
  );
};
